module.exports = __webpack_public_path__ + "img/star.2f075d41.png";